/* customized primeNG toast component */
import { animateChild, query, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { computed, ElementRef, input, NgZone, signal } from '@angular/core';
import { AppMessageComponent, AppMessagesComponent } from '@common/messages/frontend-shared';
import { GlobalMessageHandlerService } from '@core/frontend-shared';
import { DomHandler } from 'prime-ng-old/dom';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@angular/common";
const _c0 = ["container"];
const _c1 = () => ({
  "p-toast p-component": true
});
function AppMessageToast_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-message", 4, 1);
    i0.ɵɵlistener("onClose", function AppMessageToast_For_3_Template_app_message_onClose_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMessageClose($event));
    })("@toastAnimation.start", function AppMessageToast_For_3_Template_app_message_animation_toastAnimation_start_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAnimationStart($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const msg_r3 = ctx.$implicit;
    const ɵ$index_3_r4 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("message", msg_r3)("index", ɵ$index_3_r4)("template", ctx_r1.template)("@toastAnimation", undefined)("showTransitionOptions", ctx_r1.showTransitionOptions())("hideTransitionOptions", ctx_r1.hideTransitionOptions())("pauseLifeTime", ctx_r1.pauseLifeTime());
  }
}
export let AppMessageToast = /*#__PURE__*/(() => {
  class AppMessageToast extends AppMessagesComponent {
    onHoverMessageToast() {
      this.pauseLifeTime.set(true);
    }
    onLeaveMessageToast() {
      this.pauseLifeTime.set(false);
    }
    constructor(messageService, zone) {
      super(messageService, zone);
      this.messageService = messageService;
      this.zone = zone;
      this.autoZIndex = input(false, ...(ngDevMode ? [{
        debugName: "autoZIndex"
      }] : /* istanbul ignore next */[]));
      this.baseZIndex = input(99999, ...(ngDevMode ? [{
        debugName: "baseZIndex"
      }] : /* istanbul ignore next */[]));
      this.position = input('top-right', ...(ngDevMode ? [{
        debugName: "position"
      }] : /* istanbul ignore next */[]));
      this.positionClass = computed(() => {
        const pos = this.position();
        return 'p-toast-' + pos;
      }, ...(ngDevMode ? [{
        debugName: "positionClass"
      }] : /* istanbul ignore next */[]));
      this.pauseLifeTime = signal(false, ...(ngDevMode ? [{
        debugName: "pauseLifeTime"
      }] : /* istanbul ignore next */[]));
    }
    ngOnInit() {
      this.subscribe(); // toast uses root outlet, so always subscribe!
    }
    onAnimationStart(event) {
      if (event.fromState === 'void' && this.autoZIndex) {
        this.containerViewChild.nativeElement.style.zIndex = String(this.baseZIndex() + ++DomHandler.zindex);
      }
    }
    static {
      this.ɵfac = function AppMessageToast_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppMessageToast)(i0.ɵɵdirectiveInject(i1.GlobalMessageHandlerService), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: AppMessageToast,
        selectors: [["app-message-toast"]],
        viewQuery: function AppMessageToast_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.containerViewChild = _t.first);
          }
        },
        hostBindings: function AppMessageToast_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseover", function AppMessageToast_mouseover_HostBindingHandler() {
              return ctx.onHoverMessageToast();
            })("mouseleave", function AppMessageToast_mouseleave_HostBindingHandler() {
              return ctx.onLeaveMessageToast();
            });
          }
        },
        inputs: {
          autoZIndex: [1, "autoZIndex"],
          baseZIndex: [1, "baseZIndex"],
          position: [1, "position"]
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 4,
        consts: [["container", ""], ["message", ""], [3, "ngClass"], [3, "message", "index", "template", "showTransitionOptions", "hideTransitionOptions", "pauseLifeTime"], [3, "onClose", "message", "index", "template", "showTransitionOptions", "hideTransitionOptions", "pauseLifeTime"]],
        template: function AppMessageToast_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2, 0);
            i0.ɵɵrepeaterCreate(2, AppMessageToast_For_3_Template, 2, 7, "app-message", 3, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.positionClass() + " " + ctx.styleClass());
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction0(3, _c1));
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.messages());
          }
        },
        dependencies: [CommonModule, i2.NgClass, AppMessageComponent],
        styles: ["@layer primeng{.p-toast{position:fixed;width:25rem}.p-toast-message{overflow:hidden}.p-toast-message-content{display:flex;align-items:flex-start}.p-toast-message-text{flex:1 1 auto}.p-toast-top-right{top:20px;right:20px}.p-toast-top-left{top:20px;left:20px}.p-toast-bottom-left{bottom:20px;left:20px}.p-toast-bottom-right{bottom:20px;right:20px}.p-toast-top-center{top:20px;left:50%;transform:translate(-50%)}.p-toast-bottom-center{bottom:20px;left:50%;transform:translate(-50%)}.p-toast-center{left:50%;top:50%;min-width:20vw;transform:translate(-50%,-50%)}.p-toast-icon-close{display:flex;align-items:center;justify-content:center;overflow:hidden;position:relative;flex:none}.p-toast-icon-close.p-link{cursor:pointer}}.p-toast{width:320px}\n"],
        encapsulation: 2,
        data: {
          animation: [trigger('toastAnimation', [transition(':enter, :leave', [query('@*', animateChild())])])]
        },
        changeDetection: 0
      });
    }
  }
  return AppMessageToast;
})();